import React, { useEffect, useState } from "react";
import api from "utils/apiService";

import SuppliersColumn from "data/SuppliersColumn";
import { useSearchParams } from "react-router-dom";
import CheckTable from "components/CheckTable";
import HeaderButtons from "views/admin/moqawelon/components/HeaderButtons";

const Index = () => {
  const [data, setData] = useState({ data: [], pagination: { totalDocs: 0 } });
  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || 1;
  const name = searchParams.get("name") || "";
  const phoneNumber = searchParams.get("phoneNumber") || "";
  const status = searchParams.get("status") || "";

  const fetchData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("page", page);
      if (name) params.append("name", name);
      if (phoneNumber) params.append("phoneNumber", phoneNumber);
      if (status) params.append("status", status);
      const res = await api.get(`/users/suppliers?${params.toString()}`);

      if (res.error) {
        console.error("API Error:", res.error);
      } else {
        setData({
          data: res?.data || [],
          pagination: res?.pagination || { totalDocs: 0 },
        });
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, name, phoneNumber, status]);

  return (
    <section className="mt-3">
      <CheckTable
        columnsData={SuppliersColumn(fetchData)}
        tableData={data?.data}
        title="الموردون"
        loading={loading}
        extraComponent={<HeaderButtons userRole="supplier" />}
        totalCount={data?.pagination?.totalDocs}
      />
    </section>
  );
};

export default Index;
